// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../assets_c/scss/main.scss
// module id = 515
// module chunks = 1